import axios from "axios";
import { toast } from "react-toastify";
import { decrypt, encrypt } from "../utils";
import api from "../api/apiInstance";


export async function callApi(authOptions) {
  const returnVal = {};
  let responsecode = {};
  try {

    const res = await api(authOptions);
    let finalData = res.data;
    if (finalData?.isEncrypted && finalData?.data) {
      try {
        const decryptedData = decrypt(finalData.data); // decrypt from AES
        finalData = {
          ...finalData,
          data: decryptedData,
        };
      } catch (error) {
        console.error("Decryption failed:", error);
        toast.error("Failed to decrypt server response", {
          position: "bottom-center",
          autoClose: 2000,
          closeButton: false,
        });
      }
    }
    if (finalData?.success === false) {
      return {
        response_type: "fail",
        response: finalData,
        status: res.status
      };
    }

    returnVal.response_type = "success";
    returnVal.response = finalData;
    returnVal.status = res.status;
    responsecode = returnVal;
    return responsecode;
  } catch (error) {
    return {
      response_type: "fail",
      response: error?.response?.data ?? { message: "Network error" }
    };
  }
}

export const apiRequest = ({ apiUrl, method, payload, token = "", isPublic = false }) => {
  const isFormData = payload instanceof FormData;
  const options = {
    method,
    url: apiUrl,
    headers: {
      Accept: "application/json",
      "Referrer-Policy": "strict-origin-when-cross-origin",
      requestFrom: "web", isPublic
    },
  };

  // Override token manually if passed
  if (token) {
    options.headers.Authorization = `Bearer ${token}`;
  }

  // Assign correct data type
  if (method === "GET") {
    options.params = payload;
  } else {
    if(payload){
    if (isFormData) {
      // For file uploads, send FormData directly
      options.data = payload;
      // Let browser auto-set Content-Type including boundary
    } else {
      // Encrypt JSON payload
      const encryptedRequest = encrypt(payload);
      options.data = {
        encryptedRequest,
        isEncrypted: true
      };
    }
  }
    // options.data = payload;
  }
  return callApi(options);
};


export const apiRequestForTwillio = ({ apiUrl, method, payload }) => {
  let authOptions = {
    method: method,
    url: apiUrl,
    data: payload,
    headers: {
      Authorization: `Basic ${process.env.REACT_APP_TWILIO_TOKEN}`,
      "Content-Type": "application/x-www-form-urlencoded",
    },
    json: true,
  };
  return callApi(authOptions);
};


export const apiRequestPublic = ({ apiUrl, method, payload }) => {
  let authOptions = {
    method: method,
    url: apiUrl,
    data: payload,
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "Referrer-Policy": "strict-origin-when-cross-origin",
      requestFrom: "web"
    }
  };
  return callApi(authOptions);
};
